import { v4 as uuid } from 'uuid';

import appName from './app-name';
import { trafficSource } from './traffic-source';
import userAgent from './user-agent';

import type { Device } from '@shared/types/context';
import type { UBFFHeaders } from '@shared/types/ubff-headers';
import type { Nullable } from '@shared/types/utils';

import { SKYSCANNER_CORRELATION_ID } from '@shared/constants/ubff-gateway';

export type Params = {
  device: Device;
  ipAddress: string;
  isWebView?: boolean;
  utid: string;
  fromCashBack?: boolean;
  source?: Nullable<string>;
  impressionId?: Nullable<string>;
  correlationId?: string;
  skyscannerJha?: string;
  overrideFeatureTest?: Nullable<string>;
  overrideConfig?: Nullable<string>;
};

export const buildCommonUBFFHeaders = ({
  correlationId,
  device,
  fromCashBack,
  impressionId,
  ipAddress,
  isWebView,
  overrideConfig,
  overrideFeatureTest,
  skyscannerJha,
  source,
  utid,
}: Params): UBFFHeaders => ({
  'x-user-agent': userAgent({ ...device, isWebView }),
  impression_id: impressionId ?? undefined,
  [SKYSCANNER_CORRELATION_ID]: correlationId ?? uuid(),
  traffic_source: fromCashBack ? 'Cashback' : trafficSource({ source }),
  'x-user-ip': ipAddress,
  'skyscanner-utid': utid,
  from_bot: device.isRobot ? 'true' : 'false',
  app_name: appName({
    isMobilePhone: device.isMobilePhone,
    isTablet: device.isTablet,
  }),
  'skyscanner-jha': skyscannerJha,
  'skyscanner-override-experiment': overrideFeatureTest ?? undefined,
  'skyscanner-override-config': overrideConfig ?? undefined,
});
